/* Product call to action section: scroll-to-buy-box link, and the CTA add-to-cart form follows the variant
   selected in the main product form (variant id and price). */
(() => {
  if (window.__ntProductCta) return;
  window.__ntProductCta = true;

  const mainIdInput = () => document.querySelector('product-info form[data-type="add-to-cart-form"] input[name="id"]');

  document.addEventListener('click', (event) => {
    const link = event.target.closest && event.target.closest('[data-nt-cta-scroll]');
    if (!link) return;
    const id = link.dataset.ntCtaScroll;
    const target = (id && document.getElementById(id)) || document.querySelector('product-info [id^="ProductInfo-"]') || document.querySelector('product-info');
    if (!target) return;
    event.preventDefault();
    const header = document.querySelector('sticky-header, .shopify-section-header-sticky');
    const offset = header ? header.getBoundingClientRect().height + 16 : 16;
    const top = target.getBoundingClientRect().top + window.scrollY - offset;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top, behavior: reduce ? 'auto' : 'smooth' });
    const focusable = target.querySelector('[name="add"], button, a');
    if (focusable) setTimeout(() => focusable.focus({ preventScroll: true }), reduce ? 0 : 600);
  });

  // Add the variant chosen in the buy box, not the one the page loaded with.
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.closest || !form.closest('.nt-pcta')) return;
    const main = mainIdInput();
    const own = form.querySelector('[data-nt-cta-variant]');
    if (main && own && main.value) own.value = main.value;
  }, true);

  const syncPrice = (sectionId) => {
    const src = document.getElementById('price-' + sectionId);
    if (!src) return;
    const onSale = src.querySelector('.price--on-sale');
    const item = onSale ? src.querySelector('.price__sale .price-item--sale') : src.querySelector('.price__regular .price-item--regular');
    const text = item && item.textContent.trim();
    if (!text) return;
    document.querySelectorAll('[data-nt-cta-price]').forEach((el) => { el.textContent = text; });
  };

  const init = () => {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || window.__ntProductCtaSub) return;
    window.__ntProductCtaSub = true;
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const data = event && event.data;
      if (!data) return;
      syncPrice(data.sectionId);
      const btns = document.querySelectorAll('.nt-pcta form [name="add"]');
      btns.forEach((btn) => btn.toggleAttribute('disabled', data.variant ? !data.variant.available : true));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
